<template>
  <nav class="quick-widget" aria-label="Acces rapides">
    <router-link class="widget-item" to="/catalogue">
      <font-awesome-icon icon="fa-solid fa-handshake" />
      <span>Catalogue</span>
    </router-link>
    <router-link class="widget-item" to="/demande">
      <font-awesome-icon icon="fa-solid fa-headset" />
      <span>Demandez-nous</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "WidgetHome",
};
</script>

<style scoped>
.quick-widget {
  position: fixed;
  top: 38%;
  right: 18px;
  width: 178px;
  z-index: 1200;
  display: grid;
  overflow: hidden;
  border-radius: 8px;
  background: linear-gradient(180deg, #18c7e6, #3aa935);
  box-shadow: 0 16px 34px rgba(20, 31, 61, 0.24);
}

.widget-item {
  min-height: 86px;
  display: grid;
  place-items: center;
  gap: 8px;
  padding: 14px 12px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  font-weight: 800;
  border-bottom: 1px solid rgba(255, 255, 255, 0.22);
  transition: background 0.2s ease, transform 0.2s ease;
}

.widget-item:last-child {
  border-bottom: 0;
}

.widget-item svg {
  font-size: 32px;
}

.widget-item:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateX(-3px);
}

@media (max-width: 900px) {
  .quick-widget {
    top: auto;
    right: 12px;
    bottom: 14px;
    width: min(320px, calc(100vw - 24px));
    grid-template-columns: 1fr 1fr;
  }

  .widget-item {
    min-height: 66px;
    border-bottom: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.22);
    font-size: 13px;
  }

  .widget-item:last-child {
    border-right: 0;
  }

  .widget-item svg {
    font-size: 24px;
  }
}
</style>
